import { TransformableItem, TransformableItemProperties } from './Item';
import { Vector3, Euler } from 'three';

/**
 * Mesh properties
 * 
 * @property materialId - The ID of the material to use for the mesh
 * @property castShadow - Whether the mesh should cast shadows
 * @property receiveShadow - Whether the mesh should receive shadows
 * @property fbxUrl - The URL to the FBX file after upload
 */
export interface MeshProperties extends TransformableItemProperties {
  materialId?: string;
  castShadow?: boolean;
  receiveShadow?: boolean;
  fbxUrl?: string;  // URL to the FBX file after upload
}

/**
 * Mesh fields
 */
export const MeshFields = [
  {
    key: 'properties.materialId',
    type: 'material',
    label: 'Material',
    default: '',
    panel: 'material',
  },
  {
    key: 'properties.castShadow',
    type: 'boolean',
    label: 'Cast Shadow',
    default: false,
    panel: 'geometry',
  },
  {
    key: 'properties.receiveShadow',
    type: 'boolean',
    label: 'Receive Shadow',
    default: false,
    panel: 'geometry',
  },
  {
    key: 'properties.transform.position',
    type: 'vector3',
    label: 'Position',
    default: new Vector3(),
    panel: 'transform',
  },
  {
    key: 'properties.transform.rotation',
    type: 'vector3',
    label: 'Rotation',
    default: new Euler(),
    panel: 'transform',
  },
  {
    key: 'properties.transform.scale',
    type: 'vector3',
    label: 'Scale',
    default: new Vector3(),
    panel: 'transform',
  },
];

/**
 * Mesh item
 * 
 * @property type - The type of item
 * @property properties - The properties of the mesh
 * @property fields - The fields of the mesh
 * @property subtype - The subtype of the mesh
 */
export interface Mesh<P extends MeshProperties = MeshProperties> extends TransformableItem<P> {
  type: 'mesh';
  properties: P;
  fields: Array<any>;
  subtype: string;
} 